// Module
var code = `<div class="code-file" data-file-path>
    <div class="code-snippets">
        <div class="code-file-path-container"><div class="code-file-path"> </div><label class="collapse-button"><input type=checkbox></label></div>
    </div>
    <div class="child-files"></div>
</div>`;
// Exports
export default code;